import React from 'react';
import styles from '../../style/examinee/questionnaire-test-page.module.css';

// What a questionnaire shows above an item that starts something new: a later
// part's directions and rating legend, then the form's section heading. MEFS
// seeds both (PIN-341); the header keeps carrying the first part's directions.
// Items without `part` or `section` (every other questionnaire) show nothing.
const QuestionnairePartBreak = ({ item, previousItem, parts = [] }) => {
  const startsPart = item.part > 1 && item.part !== previousItem?.part;
  const partDirections = startsPart ? parts.find((p) => p.part === item.part) : undefined;
  // A new part restates its first section's heading, even under the same name.
  const startsSection =
    Boolean(item.section) &&
    (item.section !== previousItem?.section || item.part !== previousItem?.part);

  if (!partDirections && !startsSection) {
    return null;
  }

  const bullets = partDirections?.directionsBullets || [];

  return (
    <>
      {partDirections && (
        <div className={styles.directions} data-testid="questionnaire-part-directions">
          <h2 className={styles.partTitle}>{partDirections.title}</h2>
          <strong>Directions:</strong> <span>{partDirections.directions}</span>
          {bullets.length > 0 && (
            <ul className={styles.directionsBullets}>
              {bullets.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          )}
          {partDirections.directionsFooter && <p>{partDirections.directionsFooter}</p>}
        </div>
      )}
      {startsSection && (
        <h3 className={styles.sectionHeading} data-testid="questionnaire-section-heading">
          {item.section}
        </h3>
      )}
    </>
  );
};

export default QuestionnairePartBreak;
